import classNames from 'classnames'
import * as styles from './ImageAndText.module.scss'
import Heading from '../Heading/Heading'
import LinkWithArrow from '../LinkWithArrow/LinkWithArrow'

const ImageAndText = ({
  flip,
  className,
  children,
  title,
  imageProps,
  ctaProps
}) => {
  return (
    <article
      className={classNames(
        styles.imageAndText,
        flip ? styles.imageAndTextReversed : undefined,
        className
      )}>
      <picture className={styles.imageAndTextImgContainer}>
        <img
          {...imageProps}
          src={imageProps.src}
          alt={imageProps.alt}
          className={styles.imageAndTextImage}
          loading="lazy"
        />
      </picture>
      <div className={styles.imageAndTextContent}>
        <Heading headingSize="h3">{title}</Heading>
        <div className={styles.imageAndTextRte}>{children}</div>
        {ctaProps && (
          <LinkWithArrow to={ctaProps.href} external={ctaProps.external}>
            {ctaProps.text}
          </LinkWithArrow>
        )}
      </div>
    </article>
  )
}

export default ImageAndText
